(function () {
  function activateMedia(root, mediaId) {
    if (!mediaId) return;

    root.querySelectorAll("[data-new-media-item]").forEach(function (item) {
      item.classList.toggle("new-is-active", item.getAttribute("data-media-id") === String(mediaId));
    });

    root.querySelectorAll("[data-new-media-trigger]").forEach(function (trigger) {
      trigger.classList.toggle("new-is-active", trigger.getAttribute("data-media-id") === String(mediaId));
    });
  }

  function updateAddToCartState(root, variant) {
    var submitButton = root.querySelector("[data-new-add-to-cart]");
    var submitLabel = root.querySelector("[data-new-add-to-cart-label]");
    var hiddenInput = root.querySelector("[data-new-variant-id]");
    var priceNode = root.querySelector("[data-new-price]");
    var compareNode = root.querySelector("[data-new-compare-price]");
    var skuWrap = root.querySelector("[data-new-sku-wrap]");
    var skuNode = root.querySelector("[data-new-sku]");

    if (!submitButton || !submitLabel || !hiddenInput || !priceNode || !compareNode) return;

    if (!variant) {
      hiddenInput.value = "";
      submitButton.disabled = true;
      submitLabel.textContent = submitButton.dataset.labelUnavailable || "Unavailable";
      compareNode.textContent = "";
      compareNode.classList.add("new-is-hidden");
      if (skuWrap) skuWrap.classList.add("new-is-hidden");
      return;
    }

    hiddenInput.value = variant.id;
    priceNode.textContent = variant.price || "";

    if (variant.compare_at_price) {
      compareNode.textContent = variant.compare_at_price;
      compareNode.classList.remove("new-is-hidden");
    } else {
      compareNode.textContent = "";
      compareNode.classList.add("new-is-hidden");
    }

    if (skuWrap && skuNode) {
      if (variant.sku) {
        skuNode.textContent = variant.sku;
        skuWrap.classList.remove("new-is-hidden");
      } else {
        skuNode.textContent = "";
        skuWrap.classList.add("new-is-hidden");
      }
    }

    if (variant.available) {
      submitButton.disabled = false;
      submitLabel.textContent = submitButton.dataset.labelDefault || "Add to cart";
    } else {
      submitButton.disabled = true;
      submitLabel.textContent = submitButton.dataset.labelSoldOut || "Sold out";
    }

    if (variant.featured_media_id) {
      activateMedia(root, variant.featured_media_id);
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    }
  }

  function selectedOptions(root) {
    return Array.prototype.map.call(
      root.querySelectorAll("[data-new-option-group]"),
      function (group) {
        var checked = group.querySelector("[data-new-option]:checked");
        return checked ? checked.value : null;
      }
    );
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === options[index];
      });
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.newEnhanced === "true") return;

    var jsonNode = root.querySelector("[data-new-product-json]");
    if (!jsonNode) return;

    var variants;
    try {
      variants = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }

    root.dataset.newEnhanced = "true";

    root.querySelectorAll("[data-new-media-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        activateMedia(root, trigger.getAttribute("data-media-id"));
      });
    });

    root.querySelectorAll("[data-new-option]").forEach(function (input) {
      input.addEventListener("change", function () {
        updateAddToCartState(root, findVariant(variants, selectedOptions(root)));
      });
    });

    root.querySelectorAll("[data-new-quantity]").forEach(function (quantityWrap) {
      var input = quantityWrap.querySelector(".new-quantity__input");
      if (!input) return;

      quantityWrap.querySelectorAll("[data-new-quantity-control]").forEach(function (button) {
        button.addEventListener("click", function () {
          var step = button.getAttribute("data-new-quantity-control") === "increase" ? 1 : -1;
          var currentValue = parseInt(input.value || "1", 10);
          var nextValue = Math.max(1, currentValue + step);
          input.value = String(nextValue);
        });
      });
    });

    var initialVariant = null;
    var initialOptions = selectedOptions(root);

    if (initialOptions.length) {
      initialVariant = findVariant(variants, initialOptions);
    }

    if (!initialVariant) {
      var hiddenInput = root.querySelector("[data-new-variant-id]");
      if (hiddenInput) {
        initialVariant = variants.find(function (variant) {
          return String(variant.id) === hiddenInput.value;
        });
      }
    }

    updateAddToCartState(root, initialVariant || variants[0]);
  }

  function initCollection(root) {
    if (!root || root.dataset.newCollectionEnhanced === "true") return;
    root.dataset.newCollectionEnhanced = "true";

    var sortSelect = root.querySelector("[data-new-sort-select]");
    var sortForm = root.querySelector("[data-new-sort-form]");

    if (sortSelect && sortForm) {
      sortSelect.addEventListener("change", function () {
        sortForm.submit();
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-new-product-root]").forEach(initProduct);
    document.querySelectorAll("[data-new-collection-root]").forEach(initCollection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();